import { FC, useEffect, useRef, useState } from 'react';
import { PictureOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { useThemeContext, themeConfig } from '@/shared/theme';

type Props = {
  style?: React.CSSProperties;
};

export const ImagePlaceholder: FC<Props> = ({ style }) => {
  const { theme } = useThemeContext();
  const wrapperRef = useRef(null);

  const [wrapperHeight, setWrapperHeight] = useState(0);

  useEffect(() => {
    if (wrapperRef.current) {
      setWrapperHeight(
        Math.round(Math.max(wrapperRef.current?.clientHeight / 100, 2)),
      );
    }
  }, [wrapperRef.current]);

  return (
    <Wrapper
      data-testid="image-component-placeholder"
      ref={wrapperRef}
      style={{
        border: `1px solid ${themeConfig[theme].colors.imagePlaceholderBg}`,
        backgroundColor: themeConfig[theme].colors.imagePlaceholderBg,
        ...style,
      }}
    >
      <PictureOutlined
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          fontSize: `${wrapperHeight}rem`,
          color: themeConfig[theme].colors.imagePlaceholderIconColor,
        }}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 8px;
  padding-top: 56%;
`;
